/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Statement from '../Statement/Statement';
import './SpannedStatement.scss';

interface SpannedStatementProps {
  text?: string;
  limit?: number;
}

/**
 * This is the SpannedStatement component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function SpannedStatement({ text = '', limit = 50 }: SpannedStatementProps) {
  return (
    <Statement className="block spanned-statement" limit={limit}>
      {text}
    </Statement>
  );
}

export default SpannedStatement;
